import { DesktopFilterSelectOptionHrefParams } from './DesktopFilterSelectOption.types';
import { QUERY } from '@/constants/common';
import { KeywordsSource } from '@/components/SearchPanel/components/SearchSuggestions.types';
import { ROUTES } from '@/constants/routes';

export function preserveUserIdInDesktopFilterQuery(pathname: string): boolean {
  return pathname.startsWith(`${ROUTES.shops}/`);
}

export function getDesktopFilterSelectOptionHref({
  clearUrl,
  value,
  baseSearchParams,
  queryString,
  propertyParam,
  queryParam,
  pathname,
}: DesktopFilterSelectOptionHrefParams) {
  const searchParams = new URLSearchParams(baseSearchParams ?? queryString);
  const key =
    baseSearchParams || propertyParam
      ? `p[${propertyParam}]`
      : `${QUERY.q}[${queryParam}]`;

  const resolvedPath =
    pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '');
  if (!preserveUserIdInDesktopFilterQuery(resolvedPath)) {
    searchParams.delete(QUERY.userId);
  }
  searchParams.set(QUERY.keywordsSource, KeywordsSource.Typewritten);

  if (value !== undefined) {
    searchParams.set(key, value);
  } else {
    searchParams.delete(key);
  }

  return searchParams.size
    ? `${clearUrl}?${searchParams.toString()}`
    : clearUrl;
}
